export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: "zanbio",
  description:
    "Boost Your Cashflow with zanbio's automated Accounts Receivable and Payable Solutions",
  navItems: [
    {
      label: "Home",
      href: "introduction",
    },
    {
      label: "Features",
      href: "features",
    },
    {
      label: "Benefits",
      href: "benefits",
    },
    {
      label: "Blog",
      href: "/posts",
      isUrl: true,
    },
    {
      label: "About Us",
      href: "/about-us",
      isUrl: true,
    },
  ],
};
